import React from 'react';
import { DatePicker } from '@mui/x-date-pickers';
import { CalendarIcon } from 'components/Icons';
import { TextField } from '@mui/material';

function getDateValidationMessage(date, minDate, maxDate) {
  if (date?.toString() === 'Invalid Date') {
    return 'Please enter a valid date';
  }

  if (date > maxDate) {
    return 'You must be older to continue';
  }

  if (date < minDate) {
    return 'The date entered is not valid';
  }

  return '';
}

export function DateInput({ value, onChange, minDate, maxDate }) {
  const errorMessage = getDateValidationMessage(value, minDate, maxDate);

  return (
    <DatePicker
      components={{ OpenPickerIcon: CalendarIcon }}
      value={value}
      onChange={onChange}
      disableFuture
      minDate={minDate}
      maxDate={maxDate}
      openTo={'year'}
      inputFormat="MM/DD/YYYY"
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            label={value === '' ? 'Date of birth DD/MM/YYYY' : ''}
            helperText={errorMessage}
            InputLabelProps={{ shrink: false }}
            FormHelperTextProps={{
              sx: {
                color: 'red',
                fontSize: '0.85em',
                fontFamily: 'Gotham',
                opacity: 1,
              },
            }}
            sx={{
              width: '100%',
              backgroundColor: 'white',
              opacity: '1',
              borderRadius: '2em',
              '& .MuiInputLabel-root': {
                fontFamily: 'Gotham Book',
                color: '#0D345C',
                opacity: '1',
              },
              '& .MuiInputBase-input': {
                fontFamily: 'Gotham',
                color: '#0D345C',
                opacity: '1',
              },
              '& .Mui-error': {
                color: '#0D345C !important',
              },
            }}
          />
        );
      }}
    />
  );
}